import { render, staticRenderFns } from "./DangKyDDATForm.vue?vue&type=template&id=4bc898fc&scoped=true&"
import script from "./DangKyDDATForm.vue?vue&type=script&lang=js&"
export * from "./DangKyDDATForm.vue?vue&type=script&lang=js&"
import style0 from "./DangKyDDATForm.vue?vue&type=style&index=0&id=4bc898fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc898fc",
  null
  
)

export default component.exports